export const CONFIRMATION_DIALOG__DELETE_FAVICON = 'CONFIRMATION_DIALOG__DELETE_FAVICON';
